import React from 'react'
import'./Home.css'

const Home = () => {
  return (
    <div className='homeSection' id='home'>
        <video src="https://res.cloudinary.com/facemetaclone/video/upload/v1663873115/pexels-ron-lach-7959225_p84ts4.mp4" className='bgVdieo' autoPlay loop muted></video>
        <div className="contentCon">
            <h3>Hello, I'm</h3>
            <h2>Abhishek Yadav</h2>
            <p>AND THIS IS MY PORTFOLIO WEBSITE.</p>
        </div>
    </div>
  )
}

export default Home